import React, { useContext, useState } from "react";
import EinProfileForm from "./einForm";
import SoleProfileForm from "./solePropForm";
import Icon from "../../../assets/icons/icon";
import { AgentContext } from "../../../context/AgentContext";
import { useSelector } from "react-redux";

function CreateCustomerProfile({profileType, setProfileType, setAddCustProfile, submitCustomerProfile}) {
    const {isB2B} = useContext(AgentContext)
    const colorData = useSelector(state => state.colorData)

    return (
        <div className="quilityPopupFormWrapper">
            <div className="quilityPopupFormContent">
                <div className="quilityCloseWindow" onClick={()=>setAddCustProfile(false)}><span className="fontello" style={{marginTop: '-7px'}}><Icon name={'x-circle-q'} size={34} className="closeIcon" adjust="fontello" color={isB2B ? colorData['--Colors-Gray-900'] : 'currentColor'} /></span></div>
                {profileType && (
                    <div className={`${isB2B ? 'b2b ' : ''}solidQuilityActiveButton startOverButton`} onClick={()=>setProfileType(false)}>Start Over</div>
                )}
                <div className="formTitle">Create New Trust Profile</div>
                {!profileType ? (
                    <div>
                        <div className={`bigSelectionButton ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`} onClick={()=>setProfileType('ein')}>I have an EIN number</div>
                        <div className={`bigSelectionButton ${isB2B ? 'b2b ' : ''}solidQuilityActiveButton`} onClick={()=>setProfileType('sole')}>No EIN Number</div>
                    </div>
                ) : profileType==='ein' ? (
                    <EinProfileForm submitCustomerProfile={submitCustomerProfile}/>
                ) : (
                    <SoleProfileForm submitCustomerProfile={submitCustomerProfile}/>
                )}
            </div>
        </div>
    );
}

export default CreateCustomerProfile;

